(function(Updates) {
    'use strict';

    var Way2web = window.Way2web || {};

    Updates.fetchURL = false;
    Updates.section = false;
    Updates.limit = false;
    Updates.searchFilters = false;
    Updates.container = false;
    Updates.loader = false;
    Updates.cardTemplate = false;

    Updates.filters = {
        'term': '',
        'categories': [],
        'years': [],
        'businessLines': [],

        'offset': 0
    };

    Updates.initSearch = function() {
        // ensure everything we need can be found
        Updates.container = $('.js-update-container');
        Updates.loader = $('.js-update-loader');

        if (Updates.container.length === 0) {
            return; // we are not on an updates page
        }

        Updates.searchFilters = $('.js-filter-container');
        if (Updates.searchFilters.length === 0) {
            throw 'search missing update filters';
        }

        Updates.fetchURL = Updates.container.data('fetch-url');
        if (typeof Updates.fetchURL === 'undefined' || Updates.fetchURL === '') {
            throw 'search fetch url not found';
        }

        Updates.limit = Updates.container.data('limit');
        if (typeof Updates.limit === 'undefined' || Updates.limit === '') {
            throw 'search limit not found';
        }

        Updates.cardTemplate = $('.js-update-card-template');
        if (Updates.cardTemplate.length === 0) {
            throw 'search missing update card template';
        }

        Updates.section = Updates.container.data('section');

        var delay = (function() {
            var timer = 0;
            return function(callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();

        $('.js-filter-update-input').on('keyup', function() {
            delay(function() {
                Updates.doSearch(true);
            }, 300);
        });

        $('.js-update-filters-tag').on('click', function(event) {
            event.preventDefault();

            var categoryId = $(this).data('id');
            var $target = $('.js-filter-update-checkbox#' + categoryId);
            var checked = $target.prop('checked');

            if (checked) {
                $target.prop('checked', false);
            } else {
                $target.prop('checked', true);
            }

            $(this).toggleClass('is-active');

            delay(function() {
                Updates.doSearch(true);
            }, 300);
        });

        $('.js-filter-update-checkbox').on('click input', function() {
            delay(function() {
                Updates.doSearch(true);
            }, 300);
        });

        // when clicking on a checkbox in the filter panel
        // show the active state of the category
        $('.js-filter-category').on('click input', function() {
            var categoryId = $(this).val();
            $('.js-update-filters-tag[data-id="' + categoryId + '"]').toggleClass('is-active');
        });

        Updates.initUi();
        Updates.doSearch(true);
    };

    Updates.showMoreButton = function() {
        var $loadMore = $('.js-load-more-updates');

        $loadMore.removeClass('is-hidden');
    };

    Updates.hideMoreButton = function() {
        var $loadMore = $('.js-load-more-updates');

        $loadMore.addClass('is-hidden');
    };

    Updates.doSearch = function(clearUpdates) {
        if (clearUpdates) {
            Updates.filters.offset = 0;
            Updates.container.html('');
            Updates.loader.removeClass('is-hidden');
            Updates.hideMoreButton();
        }

        Updates.setFilters();
        Updates.countFilters();

        $.post(Updates.fetchURL, Updates.filters, function(data) {
            var foundUpdates = data.length;
            Updates.filters.offset = parseInt(Updates.filters.offset) + parseInt(foundUpdates);

            var updateHTML = '';

            if (data.length === 0 && clearUpdates) {
                Updates.hideMoreButton();
                $('.js-update-empty').removeClass('is-hidden');
                Updates.loader.addClass('is-hidden');
                return;
            }

            $.each(data, function(key, update) {
                updateHTML += Updates.getCardHTML(update);
            });

            Updates.loader.addClass('is-hidden');
            Updates.container.append(updateHTML);
            Way2web.initPopup();

            // did we get less updates than our limit?
            if (parseInt(foundUpdates) < parseInt(Updates.limit)) {
                Updates.hideMoreButton();
            } else {
                Updates.showMoreButton();
            }

        });
    };

    Updates.getCardHTML = function(update) {
        var cardTemplate = Updates.cardTemplate.clone();

        if (update.category) {
            cardTemplate.find('.card').addClass('card--' + update.category.slug);
        }

        if (update.summaryVideoURL !== '') {
            var cardTemplateVideo = cardTemplate.find('.js-update-video');
            var cardTemplateVideoImage = cardTemplate.find('.js-update-video-image');
            cardTemplateVideo.attr('href', update.summaryVideoURL);
            cardTemplateVideo.removeClass('u-display--none');
            if (update.summaryImage) {
                cardTemplateVideoImage.attr('src', update.summaryImage.full);
            }
        } else {
            var cardTemplateImage = cardTemplate.find('.js-update-image');
            if (update.summaryImage) {
                cardTemplateImage.find('img').attr('src', update.summaryImage.full);
            }
            cardTemplateImage.removeClass('u-display--none');
        }

        cardTemplate.find('.js-update-title').html(update.title);
        cardTemplate.find('.js-update-summary').html(update.summary);

        cardTemplate.find('.js-update-date').append(update.date);

        if (update.category) {
            cardTemplate.find('.js-update-category').html(update.category.title);
            cardTemplate.find('.js-update-category').attr('href', update.category.permalink);
        }
        cardTemplate.find('.js-update-permalink').attr('href', update.permalink);

        return cardTemplate.html();
    };

    Updates.setFilters = function() {
        var termFilter = Updates.searchFilters.find('.js-filter-term');

        var categoryFilter = Updates.searchFilters.find('.js-filter-category:checked');
        var yearFilter = Updates.searchFilters.find('.js-filter-year:checked');
        var businessLineFilter = Updates.searchFilters.find('.js-filter-businessline:checked');

        Updates.filters.term = '';
        Updates.filters.categories = [];
        Updates.filters.years = [];
        Updates.filters.businessLines = [];

        $.each(categoryFilter, function() {
            Updates.filters.categories.push($(this).val());
        });

        $.each(yearFilter, function() {
            Updates.filters.years.push($(this).val());
        });

        $.each(businessLineFilter, function() {
            Updates.filters.businessLines.push($(this).val());
        });

        if (termFilter.val() !== '') {
            Updates.filters.term = termFilter.val();
        }
    };

    Updates.countFilters = function() {
        var $counter = $('.js-update-counter');
        var totalFilters = Updates.filters.years.length +
            Updates.filters.businessLines.length;

        if (Updates.section == 'newsroom') {
            totalFilters += Updates.filters.categories.length;
        }

        if (totalFilters > 0) {
            $counter.html('(' + totalFilters + ')');
        } else {
            $counter.html('');
        }
    };

    Updates.initUi = function() {
        var $filterToggle = $('.js-update-filters-toggle');
        var $filterPanel = $('.js-update-filters-panel');
        var $loadMore = $('.js-load-more-updates');

        var $filterToggleIconDefault = $('.js-update-filters-icon-default');
        var $filterToggleIconActive = $('.js-update-filters-icon-active');

        $filterToggle.on('click', function() {
            var $label = $('.js-update-filters-toggle-text');
            var text = $label.text();
            var newText = $label.data('text');

            if (newText) {
                $label.data('text', text);
                $label.text(newText);
            }

            $filterPanel.toggleClass('is-hidden');
            $filterToggleIconDefault.toggleClass('is-hidden');
            $filterToggleIconActive.toggleClass('is-hidden');
        });

        $loadMore.on('click', function(e) {
            e.preventDefault();
            Updates.doSearch(false);
        });
    };

})(window.Way2web.Updates = window.Way2web.Updates || {});
